/**
 * Distributed tracing utilities for aircast-web.
 *
 * This module provides OpenTelemetry-based distributed tracing with
 * W3C Trace Context propagation across aircast services.
 *
 * @example Basic Usage:
 * import { withSpan } from '@/lib/tracing';
 *
 * // Create traced operation
 * await withSpan('handleCameraStream', async (span) => {
 *   span.setAttribute('camera_id', 'cam1');
 *   const result = await startCameraStream();
 *   return result;
 * });
 *
 * @example Advanced Usage with Trace Context Propagation:
 * import { withSpan, injectTraceContext } from '@/lib/tracing';
 *
 * await withSpan('sendRequest', async (span) => {
 *   // Inject W3C Trace Context for distributed tracing
 *   const traceContext = injectTraceContext();
 *
 *   const request = {
 *     action: "device.camera.stream.start",
 *     payload: { camera_id: "cam1" },
 *     trace_context: traceContext  // traceparent, tracestate
 *   };
 *
 *   await sendMessage(request);
 * });
 */

// OpenTelemetry tracer
export {
  initTracer,
  getTracer,
  withSpan,
  withSpanSync,
  getRawTraceId,
  recordError,
  addSpanAttributes,
  type TracerConfig,
} from './tracer';

// W3C Trace Context utilities for distributed tracing
export { injectTraceContext, extractTraceContext, getActiveTraceparent } from './otelBridge';
